import React from "react";

// core components
import GridItem from "../../views/Grid/GridItem.js";
import GridContainer from "../../views/Grid/GridContainer.js";
import Table from "../../views/Table/Table.js";
import Card from "../../views/Card/Card.js";
import CardHeader from "../../views/Card/CardHeader.js";
import CardBody from "../../views/Card/CardBody.js";

import axios from "axios";
import style from "./warehouse.module.css";
import Button from "@material-ui/core/Button";
import ConfWareHouse from "./confWarehouse/ConfWareHouse";
import IconButton from "@material-ui/core/IconButton";
import EditRoundedIcon from "@material-ui/icons/EditRounded";
import DeleteRoundedIcon from "@material-ui/icons/DeleteRounded";
import InputRoundedIcon from "@material-ui/icons/InputRounded";
import Snackbar from "../utils/snackbar/Snackbar";
import { withRouter } from "react-router-dom";
import WareHouseDetail from "./wareHouseDetail/WareHouseDetail";
import CircularProgress from "@material-ui/core/CircularProgress";
import TopBar from "../utils/Topbar/TopBar.js";
import StorefrontIcon from "@material-ui/icons/Storefront";
import Tooltip from "@material-ui/core/Tooltip";
import SplitButton from "../utils/SplitButton/SplitButton.js";
import { getLocations, getGoDown } from "../../containers/app/actions";
import { connect } from "react-redux";
import Inventory from "./inventory/Inventory";
import ConfirmAlert from "../utils/ConfirmAlert/ConfirmAlert.js";
import Export from "./export.js";

const Warehouses = (props) => {
  const [data, setData] = React.useState(false);

  const [filteredData, setFilteredData] = React.useState(false);
  const [searchValue, setSearchValue] = React.useState("");
  const [selectValue, setSelectValue] = React.useState("ALL");

  const [alert, setAlert] = React.useState(false);
  const [addModal, setAddModal] = React.useState(false);
  const [editModal, setEditModal] = React.useState(false);
  const [activeWarehouse, setActiveWareHouse] = React.useState(false);
  const [detailModal, setDetailModal] = React.useState(false);
  const [exportModal, setExportModal] = React.useState(false);
  const [goDown, setGoDown] = React.useState([]);
  const [location, setLocation] = React.useState([]);
  const [inventoryModal, setInventoryModal] = React.useState(false);
  const [partInventoryModal, setPartInventoryModal] = React.useState(false);

  React.useEffect(() => {
    fetchOrder();
    if (!props.locations) {
      props.getLocations(props.user._id);
    } else {
      setLocation(props.locations);
    }
    if (!props.goDown) {
      props.getGoDown(props.user._id);
    } else {
      setGoDown(props.goDown);
    }
  }, [props.goDown, props.locations]);

  React.useEffect(() => {
    if (data) {
      let arr = [];
      arr = data.filter((val) => {
        if (
          val.warehouseLocation
            .toLowerCase()
            .includes(searchValue.toLowerCase()) ||
          val.name.toLowerCase().includes(searchValue.toLowerCase()) ||
          val.address.toLowerCase().includes(searchValue.toLowerCase())
        ) {
          return val;
        }
      });
      arr = arr.filter((val) => {
        if (val.warehouseLocation == selectValue || selectValue == "ALL") {
          return val;
        }
      });
      setFilteredData(arr);
    }
  }, [searchValue, selectValue]);

  const fetchOrder = () => {
    setData(false);
    axios({
      method: "post",
      url: "/getAllWarehouse",
    })
      .then((res) => {
        setData(res.data.data);
        setFilteredData(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleDelete = (value) => {
    axios({
      method: "post",
      url: "/deleteWarehouse",
      data: {
        warehouseId: value._id,
      },
    })
      .then((res) => {
        setAlert("Deleted Successfully");
        fetchOrder();
      })
      .catch((err) => {
        setAlert("Something went wrong");
      });
  };

  // CONDITIONAL DATA
  const isLoading = !filteredData;
  const showData = !isLoading;

  // FILTER data
  let locations = ["ALL"];
  data && data.forEach((val) => locations.push(val.warehouseLocation));
  locations = [...new Set(locations)];

  // RENDER DATA
  const details = [];
  !isLoading &&
    filteredData.forEach((val, index) => {
      details.push([
        index + 1,
        val.name,
        val.warehouseLocation,
        val.contactNum,
        val.address,
        <React.Fragment>
          <Tooltip title="Explore Inventory">
            <IconButton onClick={() => setInventoryModal(val)}>
              <StorefrontIcon />
            </IconButton>
          </Tooltip>

          <Tooltip title="Warehosue Details">
            <IconButton
              onClick={() => {
                setDetailModal(true);
                setActiveWareHouse(val);
              }}
            >
              <InputRoundedIcon />
            </IconButton>
          </Tooltip>

          <Tooltip title="Edit">
            <IconButton
              onClick={() => {
                setActiveWareHouse(val);
                setEditModal(true);
              }}
            >
              <EditRoundedIcon />
            </IconButton>
          </Tooltip>

          <ConfirmAlert
            msg={`Are you sure you want delete ?`}
            onClickEvent={() => handleDelete(val)}
          >
            <Tooltip title="Delete">
              <IconButton>
                <DeleteRoundedIcon />
              </IconButton>
            </Tooltip>
          </ConfirmAlert>
        </React.Fragment>,
      ]);
    });
  return (
    <GridContainer>
      <Export
        open={exportModal}
        onClose={() => setExportModal(false)}
        onDone={() => {
          setExportModal(false);
        }}
        parts={props.parts}
        user={props.user}
      />
      {addModal && (
        <ConfWareHouse
          type="ADD"
          open={addModal}
          onClose={() => setAddModal(false)}
          onDone={() => {
            setAddModal(false);
            fetchOrder();
          }}
          setAlert={(msg) => setAlert(msg)}
          locations={location}
          goDown={goDown}
        />
      )}

      {activeWarehouse && (
        <ConfWareHouse
          type="EDIT"
          warehouse={activeWarehouse}
          open={editModal}
          onClose={() => setEditModal(false)}
          onDone={() => {
            setEditModal(false);
            setActiveWareHouse(false);
            fetchOrder();
          }}
          setAlert={(msg) => setAlert(msg)}
          locations={location}
          goDown={goDown}
        />
      )}

      {activeWarehouse && (
        <WareHouseDetail
          open={detailModal}
          onClose={() => setDetailModal(false)}
          warehouse={activeWarehouse}
        />
      )}
      {inventoryModal && (
        <Inventory
          value={inventoryModal}
          onClose={() => setInventoryModal(false)}
          user={props.user}
          setAlert={(msg) => setAlert(msg)}
        />
      )}

      <Snackbar open={alert} handleClose={() => setAlert(false)} />

      <TopBar
        searchValue={searchValue}
        onSearchChange={(value) => setSearchValue(value)}
        select={true}
        selectValue={selectValue}
        handleSelectChange={(value) => setSelectValue(value)}
        lable="Locations"
        options={locations}
        values={locations}
        multiple={true}
      />

      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="primary">
            <div className={style.cardHeader}>
              <h4>All Warehouses</h4>
              <div style={{ justifyContent: "flex-end" }}>
                <Button
                  color="secondary"
                  variant="contained"
                  onClick={() => setExportModal(true)}
                  style={{ marginRight: "20px" }}
                >
                  Generate Report
                </Button>

                <Button
                  color="secondary"
                  variant="contained"
                  onClick={() => setAddModal(true)}
                >
                  Add Ware House
                </Button>
              </div>
            </div>
          </CardHeader>
          <CardBody>
            {isLoading && (
              <div className={style.loader}>
                <CircularProgress />
              </div>
            )}

            {showData && (
              <Table
                tableHeaderColor="primary"
                tableHead={[
                  "Sl No",
                  "Name",
                  "Location",
                  "Contact Number",
                  "Address",
                  "Action",
                ]}
                tableData={details}
              />
            )}
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
};
const mapStateToProps = (state) => ({
  locations: state.appReducer.locations,
  goDown: state.appReducer.goDown,
  user: state.appReducer.user,
});

export default withRouter(
  connect(mapStateToProps, { getLocations, getGoDown })(Warehouses)
);
